import { CommonModule, NgOptimizedImage } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'

import { MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'
import { MatSliderModule } from '@angular/material/slider'
import { ColorPickerDirective } from 'ngx-color-picker'
import { SlickCarouselModule } from 'ngx-slick-carousel'

import { ThemeDirective } from './directives/theme.directive'
import { AssetUrlPipe } from './pipes/asset-url.pipe'

import { BmcoreBeatmakerInfoComponent } from './components/bmcore-beatmaker-info/bmcore-beatmaker-info.component'
import { BmcoreColorBlockHeaderComponent } from './components/bmcore-colors-block/bmcore-color-customizer/bmcore-color-block/bmcore-color-block-header/bmcore-color-block-header.component'
import { BmcoreColorBlockComponent } from './components/bmcore-colors-block/bmcore-color-customizer/bmcore-color-block/bmcore-color-block.component'
import { BmcoreColorCustomizerComponent } from './components/bmcore-colors-block/bmcore-color-customizer/bmcore-color-customizer.component'
import { BmcoreManageBlockComponent } from './components/bmcore-colors-block/bmcore-color-customizer/bmcore-manage-block/bmcore-manage-block.component'
import { BmcoreSocMediaBlockComponent } from './components/bmcore-colors-block/bmcore-color-customizer/bmcore-manage-block/bmcore-soc-media-block/bmcore-soc-media-block.component'
import { BmcoreUploadBlockComponent } from './components/bmcore-colors-block/bmcore-color-customizer/bmcore-manage-block/bmcore-upload-block/bmcore-upload-block.component'
import { BmcoreUploadProgrBarComponent } from './components/bmcore-colors-block/bmcore-color-customizer/bmcore-manage-block/bmcore-upload-block/bmcore-upload-progr-bar/bmcore-upload-progr-bar.component'
import { BmcoreColorSettingsComponent } from './components/bmcore-colors-block/bmcore-color-settings/bmcore-color-settings.component'
import { BmcoreCommentsComponent } from './components/bmcore-comments/bmcore-comments.component'
import { BmcoreContactsBlockComponent } from './components/bmcore-contacts-block/bmcore-contacts-block.component'
import { BmcoreDividingLineComponent } from './components/bmcore-dividing-line/bmcore-dividing-line.component'
import { BmcoreFollowBeatmakerBlockComponent } from './components/bmcore-follow-beatmaker-block/bmcore-follow-beatmaker-block.component'
import { BmcoreGenreCategoriesBlockComponent } from './components/bmcore-genre-categories-block/bmcore-genre-categories-block.component'
import { BmcoreGenreCategoryComponent } from './components/bmcore-genre-categories-block/bmcore-genre-category/bmcore-genre-category.component'
import { BmcoreGlobalSearchBlockComponent } from './components/bmcore-global-search-block/bmcore-global-search-block.component'
import { BmcoreGoodItemComponent } from './components/bmcore-goods-block/bmcore-good-item/bmcore-good-item.component'
import { BmcoreGoodsBlockComponent } from './components/bmcore-goods-block/bmcore-goods-block.component'
import { BmcoreNewsletterBlockComponent } from './components/bmcore-newsletter-block/bmcore-newsletter-block.component'
import { BmcoreNotificationComponent } from './components/bmcore-notification/bmcore-notification.component'
import { BmcoreProducerBgComponent } from './components/bmcore-producer-bg/bmcore-producer-bg.component'
import { BmcoreProducerPageHeaderComponent } from './components/bmcore-producer-page-header/bmcore-producer-page-header.component'
import { BmcoreProducersBlockComponent } from './components/bmcore-producers-block/bmcore-producers-block.component'
import { BmcoreServiceItemComponent } from './components/bmcore-services-block/bmcore-service-item/bmcore-service-item.component'
import { BmcoreServicesBlockComponent } from './components/bmcore-services-block/bmcore-services-block.component'
import { BmcoreSocialIconsComponent } from './components/bmcore-social-icons/bmcore-social-icons.component'
import { BmcoreStyleMoodSelectionBlockComponent } from './components/bmcore-style-mood-selection-block/bmcore-style-mood-selection-block.component'
import { BmcoreTariffBlockComponent } from './components/bmcore-tariff-block/bmcore-tariff-block.component'
import { BmcoreTariffFeatureComponent } from './components/bmcore-tariff-block/bmcore-tariff-feature/bmcore-tariff-feature.component'
import { BmcoreTextareaComponent } from './components/bmcore-textarea/bmcore-textarea.component'
import { BmcoreTrackActionsComponent } from './components/bmcore-track-actions/bmcore-track-actions.component'
import { BmcoreFindTracksComponent } from './components/bmcore-tracks-block/bmcore-find-tracks/bmcore-find-tracks.component'
import { BmcoreTrackDescrComponent } from './components/bmcore-tracks-block/bmcore-track-descr/bmcore-track-descr.component'
import { BmcoreTrackBoxCoverComponent } from './components/bmcore-tracks-block/bmcore-track-item-box/bmcore-track-box-cover/bmcore-track-box-cover.component'
import { BmcoreTrackItemBoxComponent } from './components/bmcore-tracks-block/bmcore-track-item-box/bmcore-track-item-box.component'
import { BmcoreTrackItemComponent } from './components/bmcore-tracks-block/bmcore-track-item/bmcore-track-item.component'
import { BmcoreTrackMobControlsComponent } from './components/bmcore-tracks-block/bmcore-track-item/bmcore-track-mob-controls/bmcore-track-mob-controls.component'
import { BmcoreTrackMarkerComponent } from './components/bmcore-tracks-block/bmcore-track-marker/bmcore-track-marker.component'
import { BmcoreTrackSectionInCartComponent } from './components/bmcore-tracks-block/bmcore-track-section-in-cart/bmcore-track-section-in-cart.component'
import { BmcoreTracksBlockComponent } from './components/bmcore-tracks-block/bmcore-tracks-block.component'
import { BmcoreChartToppersComponent } from './components/bmcore-tracks-block/categories/bmcore-chart-toppers/bmcore-chart-toppers.component'
import { BmcoreEditorChoiceComponent } from './components/bmcore-tracks-block/categories/bmcore-editor-choice/bmcore-editor-choice.component'
import { BmcoreHotNewTracksComponent } from './components/bmcore-tracks-block/categories/bmcore-hot-new-tracks/bmcore-hot-new-tracks.component'
import { BmcoreSpotlightTracksComponent } from './components/bmcore-tracks-block/categories/bmcore-spotlight-tracks/bmcore-spotlight-tracks.component'
import { BmcoreTopDaySellerComponent } from './components/bmcore-tracks-block/categories/bmcore-top-day-seller/bmcore-top-day-seller.component'
import { BmcoreYoutubeBlockComponent } from './components/bmcore-youtube-block/bmcore-youtube-block.component'
import { BmcoreButtonComponent } from './components/buttons/bmcore-button/bmcore-button.component'
import { BmcoreDownloadBtnComponent } from './components/buttons/bmcore-download-btn/bmcore-download-btn.component'
import { BmcoreFavBtnComponent } from './components/buttons/bmcore-fav-btn/bmcore-fav-btn.component'
import { BmcoreFollowBtnComponent } from './components/buttons/bmcore-follow-btn/bmcore-follow-btn.component'
import { BmcoreLikeBtnComponent } from './components/buttons/bmcore-like-btn/bmcore-like-btn.component'
import { BmcoreShareBtnComponent } from './components/buttons/bmcore-share-btn/bmcore-share-btn.component'
import { BmcoreFooterMenuLinksComponent } from './components/footer/bmcore-footer-menu-links/bmcore-footer-menu-links.component'
import { BmcoreLangSelectComponent } from './components/footer/bmcore-lang-select/bmcore-lang-select.component'
import { BmcoreConfirmOrderFormComponent } from './components/forms/bmcore-confirm-order-form/bmcore-confirm-order-form.component'
import { BmcoreContactsFormComponent } from './components/forms/bmcore-contacts-form/bmcore-contacts-form.component'
import { BmcoreLoginFormComponent } from './components/forms/bmcore-login-form/bmcore-login-form.component'
import { BmcoreNewPasswordFormComponent } from './components/forms/bmcore-new-password-form/bmcore-new-password-form.component'
import { BmcoreNewsletterFormComponent } from './components/forms/bmcore-newsletter-form/bmcore-newsletter-form.component'
import { BmcoreRestorePasswordFormComponent } from './components/forms/bmcore-restore-password-form/bmcore-restore-password-form.component'
import { BmcoreSignUpFormComponent } from './components/forms/bmcore-sign-up-form/bmcore-sign-up-form.component'
import { BmcoreUpdateEmailFormComponent } from './components/forms/bmcore-update-email-form/bmcore-update-email-form.component'
import { BmcoreUpdatePasswordFormComponent } from './components/forms/bmcore-update-password-form/bmcore-update-password-form.component'
import { BmcoreAccountMenuComponent } from './components/header/bmcore-account-menu/bmcore-account-menu.component'
import { BmcoreCartCounterIconComponent } from './components/header/bmcore-cart-counter/bmcore-cart-counter-icon/bmcore-cart-counter-icon.component'
import { BmcoreCartCounterComponent } from './components/header/bmcore-cart-counter/bmcore-cart-counter.component'
import { BmcoreTrackInCartPopupComponent } from './components/header/bmcore-cart-counter/bmcore-track-in-cart-popup/bmcore-track-in-cart-popup.component'
import { BmcoreLogoComponent } from './components/header/bmcore-logo/bmcore-logo.component'
import { BmcoreArrowDownIconComponent } from './components/icons/bmcore-arrow-down-icon/bmcore-arrow-down-icon.component'
import { BmcoreCartIconComponent } from './components/icons/bmcore-cart-icon/bmcore-cart-icon.component'
import { BmcoreDownloadIconComponent } from './components/icons/bmcore-download-icon/bmcore-download-icon.component'
import { BmcoreFavouriteIconComponent } from './components/icons/bmcore-favourite-icon/bmcore-favourite-icon.component'
import { BmcoreFavouriteOutlineIconComponent } from './components/icons/bmcore-favourite-outline-icon/bmcore-favourite-outline-icon.component'
import { BmcoreLikeIconComponent } from './components/icons/bmcore-like-icon/bmcore-like-icon.component'
import { BmcoreLikeOutlineIconComponent } from './components/icons/bmcore-like-outline-icon/bmcore-like-outline-icon.component'
import { BmcoreMuteIconComponent } from './components/icons/bmcore-mute-icon/bmcore-mute-icon.component'
import { BmcorePauseIconComponent } from './components/icons/bmcore-pause-icon/bmcore-pause-icon.component'
import { BmcorePlayIconComponent } from './components/icons/bmcore-play-icon/bmcore-play-icon.component'
import { BmcoreRepeatIconComponent } from './components/icons/bmcore-repeat-icon/bmcore-repeat-icon.component'
import { BmcoreRepeatOneIconComponent } from './components/icons/bmcore-repeat-one-icon/bmcore-repeat-one-icon.component'
import { BmcoreShareIconComponent } from './components/icons/bmcore-share-icon/bmcore-share-icon.component'
import { BmcoreShuffleIconComponent } from './components/icons/bmcore-shuffle-icon/bmcore-shuffle-icon.component'
import { BmcoreSkipBackIconComponent } from './components/icons/bmcore-skip-back-icon/bmcore-skip-back-icon.component'
import { BmcoreSkipForwardIconComponent } from './components/icons/bmcore-skip-forward-icon/bmcore-skip-forward-icon.component'
import { BmcoreVerifyIconComponent } from './components/icons/bmcore-verify-icon/bmcore-verify-icon.component'
import { BmcoreVolumeDownIconComponent } from './components/icons/bmcore-volume-down-icon/bmcore-volume-down-icon.component'
import { BmcoreVolumeUpIconComponent } from './components/icons/bmcore-volume-up-icon/bmcore-volume-up-icon.component'
import { BmcoreInputBComponent } from './components/inputs/bmcore-input-b/bmcore-input-b.component'
import { BmcoreInputComponent } from './components/inputs/bmcore-input/bmcore-input.component'
import { BmcoreSearchBeatInputComponent } from './components/inputs/bmcore-search-beat-input/bmcore-search-beat-input.component'
import { BmcoreSearchBeatmakerInputComponent } from './components/inputs/bmcore-search-beatmaker-input/bmcore-search-beatmaker-input.component'
import { BmcoreSearchTagInputComponent } from './components/inputs/bmcore-search-tag-input/bmcore-search-tag-input.component'
import { BmcoreSocMediaInputComponent } from './components/inputs/bmcore-soc-media-input/bmcore-soc-media-input.component'
import { BmcoreLicenseBulkDiscountComponent } from './components/license-block/bmcore-license-bulk-discount/bmcore-license-bulk-discount.component'
import { BmcoreLicenseItemComponent } from './components/license-block/bmcore-license-item/bmcore-license-item.component'
import { BmcoreLicenseListComponent } from './components/license-block/bmcore-license-list/bmcore-license-list.component'
import { BmcoreLoaderComponent } from './components/loaders/bmcore-loader/bmcore-loader.component'
import { BmcoreBeatsNotFoundComponent } from './components/not-found/bmcore-beats-not-found/bmcore-beats-not-found.component'
import { BmcoreNoMatchingSearchComponent } from './components/not-found/bmcore-no-matching-search/bmcore-no-matching-search.component'
import { BmcoreBeatmakerCatalogPageComponent } from './components/pages/bmcore-beatmaker-catalog-page/bmcore-beatmaker-catalog-page.component'
import { BmcoreBeatmakerPageComponent } from './components/pages/bmcore-beatmaker-page/bmcore-beatmaker-page.component'
import { BmcoreCartPageComponent } from './components/pages/bmcore-cart-page/bmcore-cart-page.component'
import { BmcorePaymentBlockComponent } from './components/pages/bmcore-cart-page/bmcore-payment-block/bmcore-payment-block.component'
import { BmcorePaymentBottomBlockComponent } from './components/pages/bmcore-cart-page/bmcore-payment-bottom-block/bmcore-payment-bottom-block.component'
import { BmcorePromoBlockComponent } from './components/pages/bmcore-cart-page/bmcore-promo-block/bmcore-promo-block.component'
import { BmcoreCatalogPageComponent } from './components/pages/bmcore-catalog-page/bmcore-catalog-page.component'
import { BmcoreCheckEmailPageComponent } from './components/pages/bmcore-check-email-page/bmcore-check-email-page.component'
import { BmcoreConfirmEmailPageComponent } from './components/pages/bmcore-confirm-email-page/bmcore-confirm-email-page.component'
import { BmcoreCookiePolicyPageComponent } from './components/pages/bmcore-cookie-policy-page/bmcore-cookie-policy-page.component'
import { BmcoreEditProfilePageComponent } from './components/pages/bmcore-edit-profile-page/bmcore-edit-profile-page.component'
import { BmcoreFavTracksPageComponent } from './components/pages/bmcore-fav-tracks-page/bmcore-fav-tracks-page.component'
import { BmcoreFreeBeatsPageComponent } from './components/pages/bmcore-free-beats-page/bmcore-free-beats-page.component'
import { BmcoreGoodItemPageComponent } from './components/pages/bmcore-good-item-page/bmcore-good-item-page.component'
import { BmcoreGoodsPageComponent } from './components/pages/bmcore-goods-page/bmcore-goods-page.component'
import { BmcoreLoginPageComponent } from './components/pages/bmcore-login-page/bmcore-login-page.component'
import { BmcoreNewPasswordPageComponent } from './components/pages/bmcore-new-password-page/bmcore-new-password-page.component'
import { BmcorePageNotFoundComponent } from './components/pages/bmcore-page-not-found/bmcore-page-not-found.component'
import { BmcorePurchasedTracksPageComponent } from './components/pages/bmcore-purchased-tracks-page/bmcore-purchased-tracks-page.component'
import { BmcoreRestorePasswordPageComponent } from './components/pages/bmcore-restore-password-page/bmcore-restore-password-page.component'
import { BmcoreServiceItemPageComponent } from './components/pages/bmcore-service-item-page/bmcore-service-item-page.component'
import { BmcoreServicesPageComponent } from './components/pages/bmcore-services-page/bmcore-services-page.component'
import { BmcoreSignUpPageComponent } from './components/pages/bmcore-sign-up-page/bmcore-sign-up-page.component'
import { BmcoreTechSupportPageComponent } from './components/pages/bmcore-tech-support-page/bmcore-tech-support-page.component'
import { BmcoreMinPriceComponent } from './components/pages/bmcore-track-item-page/bmcore-track-item-header/bmcore-min-price/bmcore-min-price.component'
import { BmcoreTrackItemHeaderComponent } from './components/pages/bmcore-track-item-page/bmcore-track-item-header/bmcore-track-item-header.component'
import { BmcoreTrackItemPageComponent } from './components/pages/bmcore-track-item-page/bmcore-track-item-page.component'
import { BmcoreTracksPageComponent } from './components/pages/bmcore-tracks-page/bmcore-tracks-page.component'
import { BmcorePlayerControlsComponent } from './components/player/bmcore-player-controls/bmcore-player-controls.component'
import { BmcorePlayerMobComponent } from './components/player/bmcore-player-mob/bmcore-player-mob.component'
import { BmcorePlayerVolumeControlComponent } from './components/player/bmcore-player-volume-control/bmcore-player-volume-control.component'
import { BmcorePlayerComponent } from './components/player/bmcore-player/bmcore-player.component'
import { BmcoreProgressBarComponent } from './components/player/bmcore-progress-bar/bmcore-progress-bar.component'
import { BmcoreConfirmationOrderPopupComponent } from './components/popups/bmcore-confirmation-order-popup/bmcore-confirmation-order-popup.component'
import { BmcoreCookiePolicyPopupComponent } from './components/popups/bmcore-cookie-policy-popup/bmcore-cookie-policy-popup.component'
import { BmcoreInfoPopupComponent } from './components/popups/bmcore-info-popup/bmcore-info-popup.component'
import { BmcorePurchasesPopupComponent } from './components/popups/bmcore-purchases-popup/bmcore-purchases-popup.component'
import { BmcoreLicensePopupItemComponent } from './components/popups/bmcore-select-license-popup/bmcore-license-popup-item/bmcore-license-popup-item.component'
import { BmcoreSelectLicensePopupComponent } from './components/popups/bmcore-select-license-popup/bmcore-select-license-popup.component'
import { BmcoreShareTrackPopupComponent } from './components/popups/bmcore-share-track-popup/bmcore-share-track-popup.component'
import { BmcoreStartSellingPopupComponent } from './components/popups/bmcore-start-selling-popup/bmcore-start-selling-popup.component'
import { BmcoreBestProducersComponent } from './components/producers-categories/bmcore-best-producers/bmcore-best-producers.component'
import { BmcoreProducerItemComponent } from './components/producers-categories/bmcore-best-producers/bmcore-producer-item/bmcore-producer-item.component'
import { BmcoreDaySellerProducerContentComponent } from './components/producers-categories/bmcore-day-seller-producer/bmcore-day-seller-producer-content/bmcore-day-seller-producer-content.component'
import { BmcoreDaySellerProducerComponent } from './components/producers-categories/bmcore-day-seller-producer/bmcore-day-seller-producer.component'
import { BmcorePurchasedTrackComponent } from './components/purchases-block/bmcore-purchased-track/bmcore-purchased-track.component'
import { BmcoreMonthSelectComponent } from './components/selects/bmcore-month-select/bmcore-month-select.component'
import { BmcoreMoodSelectComponent } from './components/selects/bmcore-mood-select/bmcore-mood-select.component'
import { BmcoreRatingTracksSelectComponent } from './components/selects/bmcore-rating-tracks-select/bmcore-rating-tracks-select.component'
import { BmcoreSortTracksSelectComponent } from './components/selects/bmcore-sort-tracks-select/bmcore-sort-tracks-select.component'
import { BmcoreSelectedTagsComponent } from './components/bmcore-tracks-block/bmcore-selected-tags/bmcore-selected-tags.component'
import { BmcoreRangeFilterComponent } from './components/inputs/bmcore-range-filter/bmcore-range-filter.component'
import { BmcoreDictionarySelectComponent } from './components/selects/bmcore-dictionary-select/bmcore-dictionary-select.component'
import { BmcoreStyleSelectComponent } from './components/selects/bmcore-style-select/bmcore-style-select.component'
import { BmcoreCommonSliderComponent } from './components/sliders/bmcore-common-slider/bmcore-common-slider.component'
import { BmcoreGenresSliderComponent } from './components/sliders/bmcore-genres-slider/bmcore-genres-slider.component'
import { BmcoreLicenseSliderComponent } from './components/sliders/bmcore-license-slider/bmcore-license-slider.component'
import { BmcoreWallpaperTooltipComponent } from './components/tooltips'
import { BmcoreTooltipComponent } from './components/tooltips/bmcore-tooltip/bmcore-tooltip.component'
import { CoreComponent } from './core.component'

@NgModule({
  declarations: [
    ThemeDirective,
    CoreComponent,
    BmcorePlayerComponent,
    BmcoreFavBtnComponent,
    BmcoreInfoPopupComponent,
    BmcorePlayerMobComponent,
    BmcoreProducerBgComponent,
    BmcoreTracksBlockComponent,
    BmcoreButtonComponent,
    BmcoreTrackItemPageComponent,
    BmcoreTrackItemHeaderComponent,
    BmcoreCommentsComponent,
    BmcoreTextareaComponent,
    BmcoreYoutubeBlockComponent,
    BmcoreGoodsBlockComponent,
    BmcoreGoodItemComponent,
    BmcoreGoodsPageComponent,
    BmcoreGoodItemPageComponent,
    BmcoreServicesBlockComponent,
    BmcoreServiceItemComponent,
    BmcoreServicesPageComponent,
    BmcoreServiceItemPageComponent,
    BmcoreLicenseListComponent,
    BmcoreLicenseItemComponent,
    BmcoreSelectLicensePopupComponent,
    BmcoreLicensePopupItemComponent,
    BmcoreContactsBlockComponent,
    BmcoreSocialIconsComponent,
    BmcoreNewsletterBlockComponent,
    BmcorePageNotFoundComponent,
    BmcoreTechSupportPageComponent,
    BmcoreCartPageComponent,
    BmcorePromoBlockComponent,
    BmcorePaymentBlockComponent,
    BmcoreShareBtnComponent,
    BmcoreDownloadBtnComponent,
    BmcoreConfirmationOrderPopupComponent,
    BmcorePaymentBottomBlockComponent,
    BmcoreProgressBarComponent,
    BmcorePlayerVolumeControlComponent,
    BmcoreLangSelectComponent,
    BmcoreFindTracksComponent,
    BmcoreTrackDescrComponent,
    BmcoreTrackItemComponent,
    BmcoreTrackInCartPopupComponent,
    BmcorePlayerControlsComponent,
    BmcoreCookiePolicyPageComponent,
    BmcoreCookiePolicyPopupComponent,
    BmcoreContactsFormComponent,
    BmcoreNewsletterFormComponent,
    BmcoreFooterMenuLinksComponent,
    BmcoreLicenseBulkDiscountComponent,
    BmcoreCartCounterIconComponent,
    BmcoreShareTrackPopupComponent,
    BmcoreLicenseSliderComponent,
    BmcoreTracksPageComponent,
    BmcoreColorSettingsComponent,
    BmcoreColorCustomizerComponent,
    BmcoreColorBlockComponent,
    BmcoreColorBlockHeaderComponent,
    BmcoreLoginPageComponent,
    BmcoreLoginFormComponent,
    BmcoreFavTracksPageComponent,
    BmcorePurchasedTracksPageComponent,
    BmcorePurchasedTrackComponent,
    BmcoreSpotlightTracksComponent,
    BmcoreChartToppersComponent,
    BmcoreTrackItemBoxComponent,
    BmcoreEditorChoiceComponent,
    BmcoreTopDaySellerComponent,
    BmcoreHotNewTracksComponent,
    BmcoreBestProducersComponent,
    BmcoreProducerItemComponent,
    BmcoreDaySellerProducerComponent,
    BmcoreDaySellerProducerContentComponent,
    BmcoreAccountMenuComponent,
    BmcoreEditProfilePageComponent,
    BmcoreUpdatePasswordFormComponent,
    BmcoreUpdateEmailFormComponent,
    BmcoreRestorePasswordPageComponent,
    BmcoreRestorePasswordFormComponent,
    BmcoreNewPasswordPageComponent,
    BmcoreNewPasswordFormComponent,
    BmcoreFollowBeatmakerBlockComponent,
    BmcoreGlobalSearchBlockComponent,
    BmcoreTrackBoxCoverComponent,
    BmcoreGenreCategoriesBlockComponent,
    BmcoreStyleMoodSelectionBlockComponent,
    BmcoreStyleSelectComponent,
    BmcoreDictionarySelectComponent,
    BmcoreRangeFilterComponent,
    BmcoreSelectedTagsComponent,
    BmcoreMoodSelectComponent,
    BmcoreTrackSectionInCartComponent,
    BmcoreProducersBlockComponent,
    BmcoreDividingLineComponent,
    BmcoreSignUpPageComponent,
    BmcoreSignUpFormComponent,
    BmcoreCheckEmailPageComponent,
    BmcorePurchasesPopupComponent,
    BmcoreNotificationComponent,
    BmcoreProducerPageHeaderComponent,
    BmcoreCommonSliderComponent,
    BmcoreGenresSliderComponent,
    BmcoreGenreCategoryComponent,
    BmcoreSortTracksSelectComponent,
    BmcoreConfirmEmailPageComponent,
    BmcoreNoMatchingSearchComponent,
    BmcoreConfirmOrderFormComponent,
    BmcoreVerifyIconComponent,
    BmcoreTrackMobControlsComponent,
    BmcoreMinPriceComponent,
    BmcoreInputComponent,
    BmcoreInputBComponent,
    BmcoreCartCounterComponent,
    BmcoreBeatsNotFoundComponent,
    BmcoreTariffBlockComponent,
    BmcoreStartSellingPopupComponent,
    BmcoreTariffFeatureComponent,
    BmcoreMonthSelectComponent,
    BmcoreSearchTagInputComponent,
    BmcoreSearchBeatmakerInputComponent,
    BmcoreSearchBeatInputComponent,
    BmcoreLoaderComponent,
    BmcoreTooltipComponent,
    BmcoreLogoComponent,
    BmcoreManageBlockComponent,
    BmcoreRatingTracksSelectComponent,
    BmcoreUploadBlockComponent,
    BmcoreSocMediaBlockComponent,
    BmcoreSocMediaInputComponent,
    BmcoreUploadProgrBarComponent,
    BmcoreBeatmakerPageComponent,
    BmcoreBeatmakerCatalogPageComponent,
    BmcoreWallpaperTooltipComponent,
    BmcoreCatalogPageComponent,
    BmcoreTrackMarkerComponent,
    BmcoreFreeBeatsPageComponent,
    BmcoreBeatmakerInfoComponent,
    BmcoreLikeBtnComponent,
    BmcorePlayIconComponent,
    BmcorePauseIconComponent,
    BmcoreRepeatIconComponent,
    BmcoreRepeatOneIconComponent,
    BmcoreShuffleIconComponent,
    BmcoreSkipBackIconComponent,
    BmcoreSkipForwardIconComponent,
    BmcoreArrowDownIconComponent,
    BmcoreFavouriteOutlineIconComponent,
    BmcoreFavouriteIconComponent,
    BmcoreShareIconComponent,
    BmcoreLikeOutlineIconComponent,
    BmcoreCartIconComponent,
    BmcoreDownloadIconComponent,
    BmcoreLikeIconComponent,
    BmcoreFollowBtnComponent,
    BmcoreMuteIconComponent,
    BmcoreVolumeUpIconComponent,
    BmcoreVolumeDownIconComponent,
    BmcoreTrackActionsComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SlickCarouselModule,
    ColorPickerDirective,
    MatSliderModule,
    MatSelectModule,
    MatInputModule,
    NgOptimizedImage,
    AssetUrlPipe
  ],
  exports: [
    ThemeDirective,
    AssetUrlPipe,
    CoreComponent,
    BmcorePlayerComponent,
    BmcoreFavBtnComponent,
    BmcoreInfoPopupComponent,
    BmcorePlayerMobComponent,
    BmcoreProducerBgComponent,
    BmcoreTracksBlockComponent,
    BmcoreButtonComponent,
    BmcoreTrackItemPageComponent,
    BmcoreTrackItemHeaderComponent,
    BmcoreCommentsComponent,
    BmcoreTextareaComponent,
    BmcoreYoutubeBlockComponent,
    BmcoreGoodsBlockComponent,
    BmcoreGoodItemComponent,
    BmcoreGoodsPageComponent,
    BmcoreGoodItemPageComponent,
    BmcoreServicesBlockComponent,
    BmcoreServiceItemComponent,
    BmcoreServicesPageComponent,
    BmcoreServiceItemPageComponent,
    BmcoreLicenseListComponent,
    BmcoreLicenseItemComponent,
    BmcoreSelectLicensePopupComponent,
    BmcoreLicensePopupItemComponent,
    BmcoreContactsBlockComponent,
    BmcoreSocialIconsComponent,
    BmcoreNewsletterBlockComponent,
    BmcorePageNotFoundComponent,
    BmcoreTechSupportPageComponent,
    BmcoreCartPageComponent,
    BmcorePromoBlockComponent,
    BmcorePaymentBlockComponent,
    BmcoreLicensePopupItemComponent,
    BmcoreShareBtnComponent,
    BmcoreDownloadBtnComponent,
    BmcoreConfirmationOrderPopupComponent,
    BmcorePaymentBottomBlockComponent,
    BmcoreProgressBarComponent,
    BmcorePlayerVolumeControlComponent,
    BmcoreLangSelectComponent,
    BmcoreFindTracksComponent,
    BmcoreTrackDescrComponent,
    BmcoreTrackItemComponent,
    BmcoreTrackInCartPopupComponent,
    BmcorePlayerControlsComponent,
    BmcoreCookiePolicyPageComponent,
    BmcoreCookiePolicyPopupComponent,
    BmcoreContactsFormComponent,
    BmcoreNewsletterFormComponent,
    BmcoreFooterMenuLinksComponent,
    BmcoreLicenseBulkDiscountComponent,
    BmcoreCartCounterIconComponent,
    BmcoreShareTrackPopupComponent,
    BmcoreLicenseSliderComponent,
    BmcoreTracksPageComponent,
    BmcoreColorSettingsComponent,
    BmcoreColorCustomizerComponent,
    BmcoreColorBlockComponent,
    BmcoreColorBlockHeaderComponent,
    BmcoreTracksPageComponent,
    BmcoreLoginPageComponent,
    BmcoreLoginFormComponent,
    BmcoreFavTracksPageComponent,
    BmcorePurchasedTracksPageComponent,
    BmcorePurchasedTrackComponent,
    BmcoreSpotlightTracksComponent,
    BmcoreChartToppersComponent,
    BmcoreTrackItemBoxComponent,
    BmcoreEditorChoiceComponent,
    BmcoreTopDaySellerComponent,
    BmcoreHotNewTracksComponent,
    BmcoreBestProducersComponent,
    BmcoreProducerItemComponent,
    BmcoreDaySellerProducerComponent,
    BmcoreDaySellerProducerContentComponent,
    BmcoreAccountMenuComponent,
    BmcoreEditProfilePageComponent,
    BmcoreUpdatePasswordFormComponent,
    BmcoreRestorePasswordPageComponent,
    BmcoreRestorePasswordFormComponent,
    BmcoreNewPasswordPageComponent,
    BmcoreFollowBeatmakerBlockComponent,
    BmcoreGlobalSearchBlockComponent,
    BmcoreTrackBoxCoverComponent,
    BmcoreGenreCategoriesBlockComponent,
    BmcoreStyleMoodSelectionBlockComponent,
    BmcoreStyleSelectComponent,
    BmcoreDictionarySelectComponent,
    BmcoreRangeFilterComponent,
    BmcoreSelectedTagsComponent,
    BmcoreMoodSelectComponent,
    BmcoreTrackSectionInCartComponent,
    BmcoreProducersBlockComponent,
    BmcoreDividingLineComponent,
    BmcoreSignUpPageComponent,
    BmcoreSignUpFormComponent,
    BmcoreCheckEmailPageComponent,
    BmcorePurchasesPopupComponent,
    BmcoreNotificationComponent,
    BmcoreProducerPageHeaderComponent,
    BmcoreCommonSliderComponent,
    BmcoreGenresSliderComponent,
    BmcoreGenreCategoryComponent,
    BmcoreSortTracksSelectComponent,
    BmcoreConfirmEmailPageComponent,
    BmcoreNoMatchingSearchComponent,
    BmcoreConfirmOrderFormComponent,
    BmcoreVerifyIconComponent,
    BmcoreTrackMobControlsComponent,
    BmcoreMinPriceComponent,
    BmcoreInputComponent,
    BmcoreInputBComponent,
    BmcoreCartCounterComponent,
    BmcoreBeatsNotFoundComponent,
    BmcoreTariffBlockComponent,
    BmcoreStartSellingPopupComponent,
    BmcoreTariffFeatureComponent,
    BmcoreMonthSelectComponent,
    BmcoreSearchTagInputComponent,
    BmcoreSearchBeatmakerInputComponent,
    BmcoreSearchBeatInputComponent,
    BmcoreLoaderComponent,
    BmcoreTooltipComponent,
    BmcoreLogoComponent,
    BmcoreManageBlockComponent,
    BmcoreRatingTracksSelectComponent,
    BmcoreUploadBlockComponent,
    BmcoreSocMediaBlockComponent,
    BmcoreSocMediaInputComponent,
    BmcoreUploadProgrBarComponent,
    BmcoreBeatmakerPageComponent,
    BmcoreBeatmakerCatalogPageComponent,
    BmcoreWallpaperTooltipComponent,
    BmcoreCatalogPageComponent,
    BmcoreFreeBeatsPageComponent,
    BmcoreTrackActionsComponent
  ]
})
export class CoreModule {}
